import React from "react";
import PropTypes from "prop-types";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import Seo from "../Seo";
import "./404.scss";

function NotFoundPage({ history }) {
  return (
    <div id="not-found-page">
      <Seo
        title="404"
        crawl="no"
        />
      <h1>404</h1>
      <p>Esta página não existe.</p>
      <PrimaryButton onClick={history.goBack}>Voltar</PrimaryButton>
    </div>
  );
}

NotFoundPage.propTypes = {
  /** From react router */
  history: PropTypes.object.isRequired,
};

export default NotFoundPage;
